import styled, { css, keyframes } from 'styled-components';

import disabled from '~/components/svg-icon/images/ic-24-radio-disabled.svg';
import enabled from '~/components/svg-icon/images/ic-24-radio-enabled.svg';
import selected from '~/components/svg-icon/images/ic-24-radio-selected.svg';

import checkboxStd from '~/components/styled/checkbox';

export const FormWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 80px 50px;
`;

export const Label = styled.label`
  margin-bottom: 8px;
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;

  > span {
    margin-left: 4px;
    color: #326CF9;
  }
`;

export const Input = styled.input`
  padding: 0 20px;
  height: 66px;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0px;
  border: 1px solid #EDEDED;
  border-radius: 4px;

  &:focus {
    border-color: #222222;
  }

  &::placeholder {
    color: #979797;
  }
`;

export const RadioLabel = styled.label`
  display: inline-flex;
  align-items: center;
  font-size: 20px;
  font-weight: 400;
  line-height: 32px;
  letter-spacing: 0px;
  text-align: left;

  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
`;

export const Radio = styled.input`
  width: 24px;
  height: 24px;
  margin-right: 4px;
  border: 0;
  border-radius: 0;
  background-image: url(${enabled}) ;
  background-size: cover;
  appearance: none;
  cursor: pointer;

  &:checked {
    background-image: url(${selected});
  }

  &:disabled {
    background-image: url(${disabled});
  }

  &:checked:disabled {
    background-image: url(${disabled});
  }
`;

export const RadioWrap = styled.div`
  display: flex;
  align-items: center;
`;

export const IntroduceTitle = styled.p`
  margin-top: 100px;
  padding-bottom: 10px;
  font-size: 40px;
  font-weight: 700;
  line-height: 48px;
  color: #326CF9;
  text-align: center;
  border-bottom: 2px solid #326CF9;
`;

export const UploadBtn = styled.label`
  width: 100%;
  height: 56px;
  line-height: 56px;
  border: 1px solid #DFDFDF;
  border-radius: 2px;
  text-align: center;
  cursor: pointer; 

  ${({ isDisabled }) => isDisabled && css`
    color: #CCCCCC;
    background: #FAFAFA;
    cursor: default;
  `};

  &:hover {
    background: #FAFAFA;
  }

  > input {
    display: none;
  }
`;

export const UploadFile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding: 16px 20px;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  background-color: #FCFCFC;
  border-radius: 2px;

  > p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  > img {
    cursor: pointer;
  }
`;

export const TermsWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 36px;
  background-color: #326CF9;

  > div {
    > label {
      display: inline-flex;
      align-items: center;
      font-size: 24px;
      font-weight: 700;
      line-height: 38px;
      letter-spacing: -0.5px;
      color: #ffffff;

      > svg {
        margin-left: 16px;
        width: 24px;
        height: 24px;
        cursor: pointer;

        ${({ isOpen }) => isOpen ? css`
          transform: rotate(-180deg);
          transition: transform 150ms ease;
        ` : css`
          transform: rotate(0deg);
          transition: transform 150ms ease;
        `}
      }
    }
  }

  > ul {
    margin-top: 20px;

    > li {
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      color: #ffffff;
      user-select: none;
    }
  }
`;

export const Checkbox = styled.input`
  ${checkboxStd};
  width: 24px;
  height: 24px;
  margin-right: 20px;
`;

export const QuestionText = styled.p`
  padding: 20px 30px;
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  color: #656565;
`;


export const HomeWrap = styled.div`
  position: relative;

  > button {
    background: transparent;
    border: none;
    position: absolute;

    &.home {
      width: 70%;
      height: 3%;
      bottom: 19%;
      left: 16%;
    }
  }
`;

 const spScaleAlpha = keyframes`
  0% { opacity: 1; }
  33% { opacity: 0.25; }
  66% { opacity: 0.25; }
  100% { opacity: 1; }
`;

const spScaleAlphaBefore = keyframes`
  0% { opacity: 0.25; }
  33% { opacity: 1; }
  66% { opacity: 0.25; }
`;

const spScaleAlphaAfter = keyframes`
  33% { opacity: 0.25; }
  66% { opacity: 1; }
  100% { opacity: 0.25; }
`;

export const FormBody = styled.div`
  padding-bottom: 40px;
  border: 1px solid #EDEDED;
  border-top: 0;
  position: relative;

  > button {
    width: 76%;
    height: 2%;
    background: transparent;
    border: none;
    position: absolute;
    bottom: 68px;
    left: 50%;
    transform: translateX(-50%);
  }

  /* Spinner 3Balls Scale */
  .sp-3balls, .sp-3balls:before, .sp-3balls:after {
    border-radius: 50%;
    background-color: #000;
    width: 18px;
    height: 18px;
    transform-origin: center center;
    display: inline-block;
  }
  .sp-3balls {
    position: relative;
    background-color: rgba(#000, 1);
    opacity: 1;
    -webkit-animation: ${spScaleAlpha} 1s infinite linear;
    animation: ${spScaleAlpha} 1s infinite linear;
  }
  .sp-3balls:before, .sp-3balls:after {
    content: '';
    position: relative;
    opacity: 0.25;
  }
  .sp-3balls:before {
    left: 30px;
    top: 0px;
    -webkit-animation: ${spScaleAlphaBefore} 1s infinite linear;
    animation: ${spScaleAlphaBefore} 1s infinite linear;
  }
  .sp-3balls:after {
    left: -30px;
    top: -19px;
    -webkit-animation: ${spScaleAlphaAfter} 1s infinite linear;
    animation: ${spScaleAlphaAfter} 1s infinite linear;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 2;

  > div.ball-wrap {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const UploadText = styled.p`
  margin-top: 14px;
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  color: #979797;

  & + p {
    margin-top: 0;
  }
`;

export const Textarea = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 260px;
  border: 1px solid #EDEDED;
  border-radius: 4px;

  > textarea {
    padding: 16px 16px 0;
    height: 200px;
    border: 0;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    resize: none;
  }

  > div {
    margin-top: auto;
    padding: 16px;
    font-size: 16px;
    font-weight: 400;
    text-align: right;
    line-height: 26px;
    color: #979797;
  }

  ${({ isFocus }) => isFocus && css`
    border-color: #222222;

    > div {
      color: #222222;
    }
  `};
`;
